
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.904 16.67v-6.278c0-5.196 4.376-9.31 9.65-9.31s9.65 4.222 9.65 9.31v6.278","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M20.206 17.753c0 1.19-1.004 2.056-2.12 2.056H16.97c-1.227 0-2.12-.974-2.12-2.056v-3.14c0-1.19 1.005-2.056 2.12-2.056h3.236v5.196zm-19.302 0c0 1.19 1.004 2.056 2.12 2.056H4.14c1.227 0 2.12-.974 2.12-2.056v-3.14c0-1.19-1.004-2.056-2.12-2.056H.904v5.196z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    